var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "background" },
    [
      _c("TitleWidget", { attrs: { title: "社員データ" } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
                "label-width": "250px"
              }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 15 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "cls_avatar",
                              attrs: {
                                label: "社員写真添付 ※ 写真１枚まで添付可能"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "colorButton",
                                  attrs: { id: "pick-avatar", size: "small" },
                                  on: {
                                    click: function() {
                                      _vm.dataCropper.triggerCropImage = true
                                    }
                                  }
                                },
                                [_vm._v("ファイルを選択")]
                              ),
                              _vm._v(" "),
                              _c("avatar-cropper", {
                                staticStyle: { "margin-top": "8px" },
                                attrs: {
                                  "upload-handler": _vm.cropperHandler,
                                  trigger: "#pick-avatar",
                                  labels: {
                                    submit: "切る",
                                    cancel: "キャンセル"
                                  }
                                },
                                on: {
                                  changed: _vm.handleUploading,
                                  error: function($event) {
                                    return _vm.handlerError()
                                  }
                                },
                                model: {
                                  value: _vm.dataCropper.triggerCropImage,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataCropper,
                                      "triggerCropImage",
                                      $$v
                                    )
                                  },
                                  expression: "dataCropper.triggerCropImage"
                                }
                              }),
                              _vm._v(" "),
                              _vm.dataCropper.urlImage
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "preview",
                                      attrs: { src: _vm.dataCropper.urlImage }
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "el-icon-circle-close",
                                      on: { click: _vm.handleDeleteAvatar }
                                    })
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "所属グループ",
                                error: _vm.errorMessageOrganization,
                                rules: { required: false }
                              }
                            },
                            [
                              _vm.props.length !== 0
                                ? _c(
                                    "el-card",
                                    { staticClass: "box-card" },
                                    [
                                      _c("el-tree", {
                                        attrs: {
                                          data: _vm.props,
                                          "show-checkbox": "",
                                          "node-key": "id",
                                          props: _vm.defaultProps,
                                          "check-strictly": "",
                                          "default-checked-keys": []
                                        },
                                        on: {
                                          "check-change": _vm.handleCheckChange
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-drawer",
                        {
                          attrs: {
                            visible: _vm.drawer,
                            "with-header": false,
                            size: "auto"
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.drawer = $event
                            }
                          }
                        },
                        [
                          _c("AffiliationGroup", {
                            key: _vm.keyAffiliation,
                            on: {
                              panretToggleDrawer: _vm.swapAffiliationComponent
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 8, lg: 8, xl: 8, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "last_name",
                                label: "社員名（姓）"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.last_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "last_name", $$v)
                                  },
                                  expression: "form.last_name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { md: 8, lg: 8, xl: 8, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "name", label: "社員名（名）" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "name", $$v)
                                  },
                                  expression: "form.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { md: 8, lg: 8, xl: 8, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "入社年月日" } },
                            [
                              _c(
                                "div",
                                { staticClass: "block" },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      format: "yyyy-MM-dd",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.form.company.join_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "join_date",
                                          $$v
                                        )
                                      },
                                      expression: "form.company.join_date"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 8, lg: 8, xl: 8, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "last_name_furigana",
                                label: "社員名（ふりがな姓）"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.last_name_furigana,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "last_name_furigana",
                                      $$v
                                    )
                                  },
                                  expression: "form.last_name_furigana"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { md: 8, lg: 8, xl: 8, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "name_furigana",
                                label: "社員名（ふりがな名）"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.name_furigana,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "name_furigana", $$v)
                                  },
                                  expression: "form.name_furigana"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { md: 10, lg: 10, xl: 10, sm: 10, xs: 4 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.phone_number,
                              attrs: {
                                prop: "company.phone_number1",
                                rules: [
                                  {
                                    required: false,
                                    validator: _vm.validateRequirePhone,
                                    colname: "電話番号"
                                  },
                                  {
                                    required: false,
                                    validator: _vm.tel1,
                                    colname: ""
                                  }
                                ],
                                label: "電話番号"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.phone_number1,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.company,
                                      "phone_number1",
                                      $$v
                                    )
                                  },
                                  expression: "form.company.phone_number1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 1, align: "center" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { visibility: "hidden" },
                              attrs: { label: "-" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    visibility: "visible",
                                    color: "black"
                                  }
                                },
                                [_vm._v("-")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.phone_number,
                              attrs: {
                                prop: "company.phone_number2",
                                rules: [
                                  {
                                    required: false,
                                    validator: _vm.validateRequirePhone,
                                    colname: "電話番号"
                                  },
                                  {
                                    required: false,
                                    validator: _vm.tel2,
                                    colname: ""
                                  }
                                ],
                                label: _vm.space
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.phone_number2,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.company,
                                      "phone_number2",
                                      $$v
                                    )
                                  },
                                  expression: "form.company.phone_number2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 1, align: "center" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { visibility: "hidden" },
                              attrs: { label: "-" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    visibility: "visible",
                                    color: "black"
                                  }
                                },
                                [_vm._v("-")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.phone_number,
                              attrs: {
                                prop: "company.phone_number3",
                                rules: [
                                  {
                                    required: false,
                                    validator: _vm.validateRequirePhone,
                                    colname: "電話番号"
                                  },
                                  {
                                    required: false,
                                    validator: _vm.tel3,
                                    colname: ""
                                  }
                                ],
                                label: _vm.space
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.phone_number3,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.company,
                                      "phone_number3",
                                      $$v
                                    )
                                  },
                                  expression: "form.company.phone_number3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { md: 10, lg: 10, xl: 10, sm: 10, xs: 4 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.upload_mobile,
                              attrs: {
                                prop: "company.mobile_phone1",
                                rules: [
                                  {
                                    required: false,
                                    validator: _vm.validateRequireMobile,
                                    colname: "携帯電話"
                                  },
                                  {
                                    required: false,
                                    validator: _vm.tel1,
                                    colname: ""
                                  }
                                ],
                                label: "携帯電話"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.mobile_phone1,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.company,
                                      "mobile_phone1",
                                      $$v
                                    )
                                  },
                                  expression: "form.company.mobile_phone1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 1, align: "center" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { visibility: "hidden" },
                              attrs: { label: "-" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    visibility: "visible",
                                    color: "black"
                                  }
                                },
                                [_vm._v("-")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.upload_mobile,
                              attrs: {
                                prop: "company.mobile_phone2",
                                rules: [
                                  {
                                    required: false,
                                    validator: _vm.validateRequireMobile,
                                    colname: "携帯電話"
                                  },
                                  {
                                    required: false,
                                    validator: _vm.tel2,
                                    colname: ""
                                  }
                                ],
                                label: _vm.space
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.mobile_phone2,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.company,
                                      "mobile_phone2",
                                      $$v
                                    )
                                  },
                                  expression: "form.company.mobile_phone2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 1, align: "center" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { visibility: "hidden" },
                              attrs: { label: "-" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    visibility: "visible",
                                    color: "black"
                                  }
                                },
                                [_vm._v("-")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.upload_mobile,
                              attrs: {
                                prop: "company.mobile_phone3",
                                rules: [
                                  {
                                    required: false,
                                    validator: _vm.validateRequireMobile,
                                    colname: "携帯電話"
                                  },
                                  {
                                    required: false,
                                    validator: _vm.tel3,
                                    colname: ""
                                  }
                                ],
                                label: _vm.space
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.mobile_phone3,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.company,
                                      "mobile_phone3",
                                      $$v
                                    )
                                  },
                                  expression: "form.company.mobile_phone3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { md: 10, lg: 10, xl: 10, sm: 10, xs: 4 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.upload_fax,
                              attrs: {
                                prop: "company.fax1",
                                rules: [
                                  {
                                    required: false,
                                    validator: _vm.validateRequireFax,
                                    colname: "FAX"
                                  },
                                  {
                                    required: false,
                                    validator: _vm.tel1,
                                    colname: ""
                                  }
                                ],
                                label: "FAX"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.fax1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.company, "fax1", $$v)
                                  },
                                  expression: "form.company.fax1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 1, align: "center" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { visibility: "hidden" },
                              attrs: { label: "-" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    visibility: "visible",
                                    color: "black"
                                  }
                                },
                                [_vm._v("-")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.upload_fax,
                              attrs: {
                                prop: "company.fax2",
                                rules: [
                                  {
                                    required: false,
                                    validator: _vm.validateRequireFax,
                                    colname: "FAX"
                                  },
                                  {
                                    required: false,
                                    validator: _vm.tel2,
                                    colname: ""
                                  }
                                ],
                                label: _vm.space
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.fax2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.company, "fax2", $$v)
                                  },
                                  expression: "form.company.fax2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 1, align: "center" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { visibility: "hidden" },
                              attrs: { label: "-" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    visibility: "visible",
                                    color: "black"
                                  }
                                },
                                [_vm._v("-")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.upload_fax,
                              attrs: {
                                prop: "company.fax3",
                                rules: [
                                  {
                                    required: false,
                                    validator: _vm.validateRequireFax,
                                    colname: "FAX"
                                  },
                                  {
                                    required: false,
                                    validator: _vm.tel3,
                                    colname: ""
                                  }
                                ],
                                label: _vm.space
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.fax3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.company, "fax3", $$v)
                                  },
                                  expression: "form.company.fax3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "company.email",
                                rules: {
                                  required: false,
                                  validator: _vm.email,
                                  colname: "Email"
                                },
                                label: "Email"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.company.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.company, "email", $$v)
                                  },
                                  expression: "form.company.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "position", label: "役職名" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.position,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "position", $$v)
                                  },
                                  expression: "form.position"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "その他（全角100文字まで入力可能）"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  "show-word-limit": "",
                                  type: "textarea",
                                  rows: 5,
                                  maxlength: "100"
                                },
                                model: {
                                  value: _vm.form.others,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "others", $$v)
                                  },
                                  expression: "form.others"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "employee_id",
                                rules: {
                                  required: false,
                                  validator: _vm.validateRequireEmployee,
                                  colname: "社員番号"
                                },
                                label: "社員番号"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.employee_id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "employee_id", $$v)
                                  },
                                  expression: "form.employee_id"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "password",
                                label: "社員パスワード"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  autocomplete: "new-password",
                                  "show-password": "",
                                  placeholder: "Password",
                                  name: "password"
                                },
                                model: {
                                  value: _vm.form.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "password", $$v)
                                  },
                                  expression: "form.password"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "confirmation_password",
                                label: "社員パスワード（確認用）"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  "show-password": "",
                                  type: "password"
                                },
                                model: {
                                  value: _vm.form.confirmation_password,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "confirmation_password",
                                      $$v
                                    )
                                  },
                                  expression: "form.confirmation_password"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "divider" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "title-tab-user" }, [
                    _vm._v("会社情報")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 50 } },
                        [
                          _c(
                            "el-col",
                            {
                              attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "会社名" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.company.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form.company, "name", $$v)
                                      },
                                      expression: "form.company.name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 50 } },
                        [
                          _c(
                            "el-col",
                            {
                              attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "会社名（ふりがな）" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.company.name_furigana,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "name_furigana",
                                          $$v
                                        )
                                      },
                                      expression: "form.company.name_furigana"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  key: _vm.upload_postcode,
                                  attrs: {
                                    prop: "company.postcode1",
                                    rules: [
                                      {
                                        required: false,
                                        validator: _vm.validateRequire,
                                        colname: "郵便番号"
                                      },
                                      {
                                        required: false,
                                        validator: _vm.postcode1,
                                        colname: ""
                                      }
                                    ],
                                    label: "郵便番号"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.company.postcode1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "postcode1",
                                          $$v
                                        )
                                      },
                                      expression: "form.company.postcode1"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 1, align: "center" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { visibility: "hidden" },
                                  attrs: { label: "-" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        visibility: "visible",
                                        color: "black"
                                      }
                                    },
                                    [_vm._v("-")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { md: 4, lg: 4, xl: 4, sm: 4, xs: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  key: _vm.upload_postcode,
                                  attrs: {
                                    prop: "company.postcode2",
                                    rules: [
                                      {
                                        required: false,
                                        validator: _vm.validateRequire,
                                        colname: "郵便番号"
                                      },
                                      {
                                        required: false,
                                        validator: _vm.postcode2,
                                        colname: "郵便番号"
                                      }
                                    ],
                                    label: _vm.space
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.company.postcode2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "postcode2",
                                          $$v
                                        )
                                      },
                                      expression: "form.company.postcode2"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 50 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "会社所在地" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.company.address_1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "address_1",
                                          $$v
                                        )
                                      },
                                      expression: "form.company.address_1"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 50 } },
                        [
                          _c(
                            "el-col",
                            {
                              attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "company.address_2",
                                    label: "ビル名"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.company.address_2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "address_2",
                                          $$v
                                        )
                                      },
                                      expression: "form.company.address_2"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 50 } },
                        [
                          _c(
                            "el-col",
                            {
                              attrs: { md: 12, lg: 12, xl: 12, sm: 12, xs: 24 }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "company.website",
                                    rules: {
                                      required: false,
                                      validator: _vm.url,
                                      colname: "ホームページ"
                                    },
                                    label: "ホームページ"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.company.website,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "website",
                                          $$v
                                        )
                                      },
                                      expression: "form.company.website"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "事業内容（全角256文字まで入力可能）"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 5,
                              maxlength: "256"
                            },
                            model: {
                              value: _vm.form.company.business_descriptions,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.company,
                                  "business_descriptions",
                                  $$v
                                )
                              },
                              expression: "form.company.business_descriptions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { md: 8, lg: 8, xl: 8, sm: 8, xs: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "company.established",
                                    label: "設立年月日"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "block" },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          "picker-options":
                                            _vm.datePickerOptions,
                                          format: "yyyy-MM-dd",
                                          type: "date"
                                        },
                                        model: {
                                          value: _vm.form.company.established,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form.company,
                                              "established",
                                              $$v
                                            )
                                          },
                                          expression: "form.company.established"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { md: 6, lg: 6, xl: 6, sm: 7, xs: 18 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "company.capital_stock",
                                    rules: {
                                      validator: _vm.checkNumber,
                                      colname: "資本金"
                                    },
                                    label: "資本金"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.company.capital_stock,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "capital_stock",
                                          $$v
                                        )
                                      },
                                      expression: "form.company.capital_stock"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { md: 2, lg: 2, xl: 2, sm: 2, xs: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { visibility: "hidden" },
                                  attrs: { label: "万円" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        visibility: "visible",
                                        color: "black"
                                      }
                                    },
                                    [_vm._v("万円")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { md: 6, lg: 6, xl: 6, sm: 7, xs: 20 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "company.employees",
                                    rules: {
                                      validator: _vm.checkNumber,
                                      colname: "社員数"
                                    },
                                    label: "社員数"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.company.employees,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "employees",
                                          $$v
                                        )
                                      },
                                      expression: "form.company.employees"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { visibility: "hidden" },
                                  attrs: { label: "人" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        visibility: "visible",
                                        color: "black"
                                      }
                                    },
                                    [_vm._v("人")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { md: 6, lg: 6, xl: 6, sm: 7, xs: 20 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "company.employees_part_time",
                                    rules: {
                                      validator: _vm.checkNumber,
                                      colname: "パート・アルバイト数"
                                    },
                                    label: "パート・アルバイト数"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value:
                                        _vm.form.company.employees_part_time,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.company,
                                          "employees_part_time",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.company.employees_part_time"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { visibility: "hidden" },
                                  attrs: { label: "人" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        visibility: "visible",
                                        color: "black"
                                      }
                                    },
                                    [_vm._v("人")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("hr", { staticClass: "divider" }),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "show_company_info",
                        label: "アプリへのプロフィール情報"
                      }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 4, lg: 4, xl: 4, sm: 24, xs: 24 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "必ず一つ選択してください"
                              },
                              model: {
                                value: _vm.form.show_company_info,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "show_company_info", $$v)
                                },
                                expression: "form.show_company_info"
                              }
                            },
                            _vm._l(_vm.displays, function(item) {
                              return _c("el-option", {
                                key: item.no,
                                attrs: { label: item.title, value: item.no }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 24, md: 4, lg: 4, xl: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "user_type",
                            rules: {
                              required: true,
                              validator: _vm.validateRequireOption,
                              colname: "ユーザーの役割"
                            },
                            label: "ユーザーの役割"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                float: "left",
                                "line-height": "3"
                              },
                              attrs: {
                                placeholder: "必ず一つ選択してください"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onChangePermission(
                                    _vm.form.user_type
                                  )
                                }
                              },
                              model: {
                                value: _vm.form.user_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "user_type", $$v)
                                },
                                expression: "form.user_type"
                              }
                            },
                            _vm._l(_vm.userRoles, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 24, md: 20, lg: 20, xl: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { visibility: "hidden" },
                          attrs: { label: "-" }
                        },
                        [
                          _vm.role_permission.showWindow
                            ? _c(
                                "div",
                                { staticStyle: { visibility: "visible" } },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "18px" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value:
                                              _vm.role_permission
                                                .enablePrivateChat,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.role_permission,
                                                "enablePrivateChat",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "role_permission.enablePrivateChat"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.role_permission
                                                .textShowCheckBox
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-tooltip",
                                        { attrs: { placement: "top" } },
                                        [
                                          _c("div", {
                                            attrs: { slot: "content" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.mark_description
                                              )
                                            },
                                            slot: "content"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                border: "none !important"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-question",
                                                staticStyle: {
                                                  "font-size": "20px"
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("Button", {
            attrs: {
              title: "登録",
              width: "140",
              "is-loading": _vm.waitDialogVisible
            },
            on: { handleClick: _vm.postFromCheck }
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-user" }, [
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "title-tab-user" }, [
        _vm._v("個人情報 "),
        _c("span", { staticStyle: { color: "#ff4949", "font-size": "14px" } }, [
          _vm._v("＊は必須項目です。")
        ])
      ]),
      _vm._v(" "),
      _c("br")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }